import * as Style from "../style/StyledComponents";
import Navbar from "./Navbar";
import {Mint} from "./Mint";
import { abbreviateAddress, chain, contractAddress, links } from "./Config";

import imgHero from "../images/bones.png";

function SectionHero() {
	return (
         <Style.Section>
      		<Style.HeroContainer >	


      			<Style.ColumnHeroDesc>

      			   <h1>- Shrines -</h1>
				   <p style={{fontSize:"0.9em"}}>by <a href={links.twitter} target="_blank" rel="noreferrer">@dailofrog</a></p>
				   <br/>
      				{/*<p>100% fully onchain eternal death relics on <a href={links.megaeth} target="_blank">MegaETH</a>. No future but forever, no promise but bone.</p>*/}
					{/*<p>100% fully onchain, sealed in <a href={links.megaeth} target="_blank">MegaETH</a>, ancient shrines of death lie cursed with hollowed souls. No dawn, no oath — only eternal silence.</p>*/}
					<p>A monument to the fallen. Here lies the <a href={links.txnContractCreation} target="_blank" rel="noreferrer">first collection</a> sealed in <a href={links.megaeth} target="_blank" rel="noreferrer">MegaETH</a>. Shrines of the hollowed, preserved fully on-chain. No light, no oath — only eternal silence.</p>
					  <br/>
					<div style={{margin:"0 auto", marginTop:"10px", userSelect:"none", WebkitUserSelect:"none", MozUserSelect:"none", msUserSelect:"none", pointerEvents:"none"}}>
      			    <Style.ResponsiveImage src={imgHero} style={{userSelect:"none", WebkitUserSelect:"none", MozUserSelect:"none", msUserSelect:"none", pointerEvents:"none", WebkitUserDrag:"none", imageRendering:"pixelated", filter:"drop-shadow(4px 4px 8px rgba(0, 0, 0, 0.2))"}} />
      			    </div>

              <br/>
			  <br/>

              <Mint/>
      				
              <br/>
			  <br/>
      				<h2>- Collection Info -</h2>
              <hr/>
      				<p style={{fontSize:"0.8em", lineHeight:"1.6rem", textAlign:"center"}}>
					  ◦ First NFT collection on <a href={links.megaeth} target="_blank" rel="noreferrer">MegaETH</a><br/>
					  {/*◦ Secondary Market: <a href={links.driptrade} target="_blank">drip.trade</a> or <a href={links.net} target="_blank">Net</a><br/>*/}
          ◦ Pixel Art: <a href={links.twitterGoop} target="_blank" rel="noreferrer">@goopgoop_art</a><br/>
					
					
          ◦ Total Supply: 2,222<br/>
					{/*◦ Mint Price (each): 1 $HYPE<br/>*/}
					◦ Deployed: <a href={links.txnContractCreation} target="_blank" rel="noreferrer">Nov 14, 2025</a> (<a href={"https://x.com/poptyedev/status/1989041878549881041"} target="_blank" rel="noreferrer">RPC leak</a>)<br/>
		  ◦ Storage: 100% Onchain<br/>
		  ◦ Token Standard: <a href="https://eips.ethereum.org/EIPS/eip-721" target="_blank" rel="noreferrer">ERC-721</a><br/>
      		◦ Network: <a href={links.megaeth} target="_blank" rel="noreferrer">{chain.name}</a><br/>
					◦ Contract: <a href={links.contractFrontEnd} target="_blank" rel="noreferrer">{abbreviateAddress(contractAddress,5)}</a><br/>
					<br/>
					No roadmap, no utility — only hollowed remains.<br/>
					{/*◦ Phase II: Ashen Consecration (?)<br/>
					◦ Whitelist: <a href="https://linktr.ee/dailofrog" target="_blank">dailofrog collection</a> holders, <a href="https://x.com/tinyhypercats" target="_blank">tiny hyper cats</a><br/>*/}
          {/*◦ Marketplace: <a href={links.opensea} target="_blank">Net</a>*/}
					</p>


			
      			</Style.ColumnHeroDesc>
      		</Style.HeroContainer>

			<Style.Copyright>
				<p>© {new Date().getFullYear()} Dailofrog Technologies. All Rights Reserved.</p>
			</Style.Copyright>
       
         </Style.Section>)
}

function FrontPage() {
  return (
      <>
        <SectionHero/>
      </>
  );
}

export default FrontPage;
